import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { autoTradingApi } from "@/api/autoTradingApi";

export const AUTO_TRADING_QUERY_KEYS = {
  STATUS: ["auto-trading", "status"],
};

export function useAutoTrading() {
  const queryClient = useQueryClient();

  const statusQuery = useQuery({
    queryKey: AUTO_TRADING_QUERY_KEYS.STATUS,
    queryFn: () => autoTradingApi.getStatus(),
  });

  const startMutation = useMutation({
    mutationFn: () => autoTradingApi.start(),
    onSuccess: (data) => {
      queryClient.setQueryData(AUTO_TRADING_QUERY_KEYS.STATUS, data);
    },
  });

  const stopMutation = useMutation({
    mutationFn: () => autoTradingApi.stop(),
    onSuccess: (data) => {
      queryClient.setQueryData(AUTO_TRADING_QUERY_KEYS.STATUS, data);
    },
  });

  const updateAccountMutation = useMutation({
    mutationFn: (accountUuid: string) => autoTradingApi.updateAccountUuid(accountUuid),
    onSuccess: (data) => {
      queryClient.setQueryData(AUTO_TRADING_QUERY_KEYS.STATUS, data);
    },
  });

  const isRunning = statusQuery.data?.state === "running";
  const isPending = statusQuery.data?.state === "pending_switch";

  return {
    status: statusQuery.data,
    isLoading: statusQuery.isLoading,
    error: statusQuery.error,
    refetch: statusQuery.refetch,

    isRunning,
    isPending,

    start: startMutation.mutate,
    startAsync: startMutation.mutateAsync,
    isStarting: startMutation.isPending,
    startError: startMutation.error,

    stop: stopMutation.mutate,
    stopAsync: stopMutation.mutateAsync,
    isStopping: stopMutation.isPending,
    stopError: stopMutation.error,

    updateAccount: updateAccountMutation.mutate,
    updateAccountAsync: updateAccountMutation.mutateAsync,
    isUpdatingAccount: updateAccountMutation.isPending,
    updateAccountError: updateAccountMutation.error,
  };
}
